module.exports = __webpack_public_path__ + "static/media/imagenPrincipal.2e2a5067.png";